import React, { useState, useEffect, useRef, useCallback } from "react";
import { motion, useScroll, useTransform, AnimatePresence, useInView } from "framer-motion";
import Header1 from "./Header/Header1";
import Footer from "./Footer/Footer";
import { useNavigate } from "react-router-dom";


const ACCENT = "#1E90FF";

const publicAsset = (fileName) => `${process.env.PUBLIC_URL}/${fileName}`;

export const blogs = [
  {
    id: 1,
    title: "Understanding AI-Driven Digital Transformation",
    slug: "understanding-ai-driven-digital-transformation",
    category: "Enterprise AI",
    image: publicAsset("img1.png"),
    excerpt: "How AI is driving digital transformation across industries and why enterprises must act now to stay ahead in an increasingly AI-driven world.",
    readTime: "8 min read",
    date: "Jun 3, 2025",
    featured: true,
  },
  {
    id: 2,
    title: "Why Every Enterprise Needs an AI Transformation Roadmap",
    slug: "why-every-enterprise-needs-an-ai-transformation-roadmap",
    category: "Enterprise AI",
    image: publicAsset("img2.png"),
    excerpt: "An AI transformation roadmap provides a strategic framework that aligns AI initiatives with business goals, ensures effective resource allocation, and creates a clear path from experimentation to enterprise-wide adoption.",
    readTime: "6 min read",
    date: "May 28, 2025",
  },
  {
    id: 3,
    title: "RAG vs Fine-Tuning",
    slug: "rag-vs-fine-tuning",
    category: "RAG",
    image: publicAsset("img3.png"),
    excerpt: "RAG vs Fine-Tuning: Choosing the Right Approach for Enterprise AI. In this article, we'll explore the differences between RAG and Fine-Tuning, compare their strengths and limitations, and help enterprises determine the best strategy for their AI initiatives.",
    readTime: "10 min read",
    date: "May 20, 2025",
  },
  {
    id: 4,
    title: "Build Secure AI Assistants with Private LLMs",
    slug: "build-secure-ai-assistants-with-private-llms",
    category: "Agents",
    image: publicAsset("img4.png"),
    excerpt: "How Enterprises Can Build Secure AI Assistants with Private LLMs: A Comprehensive Guide to Protecting Data and Ensuring Compliance",
    readTime: "7 min read",
    date: "May 14, 2025",
  },
  {
    id: 5,
    title: "How AI Is Revolutionizing Manufacturing and Supply Chains",
    slug: "how-ai-is-revolutionizing-manufacturing-and-supply-chains",
    category: "Engineering",
    image: publicAsset("img5.png"),
    excerpt: "Manufacturing and supply chain operations are the backbone of the global economy.",
    readTime: "9 min read",
    date: "May 5, 2025",
  },
  {
    id: 6,
    title: "The Future of Enterprise Efficiency",
    slug: "the-future-of-enterprise-efficiency",
    category: "Enterprise AI",
    image: publicAsset("img6.png"),
    excerpt: "From Manual Workflows to Autonomous Operations: The Future of Enterprise Efficiency",
    readTime: "5 min read",
    date: "Apr 29, 2025",
  },
  {
    id: 7,
    title: "The Impact of AI on Banking, Financial Services, and Insurance",
    slug: "the-impact-of-ai-on-banking-financial-services-and-insurance",
    category: "Research",
    image: publicAsset("img7.png"),
    excerpt: "For banks, insurers, and financial service providers, AI is no longer a future investment—it is a competitive necessity.",
    readTime: "8 min read",
    date: "Apr 29, 2025",
  },
  {
    id: 8,
    title: "AI-Powered Healthcare: Improving Outcomes and Efficiency",
    slug: "ai-powered-healthcare-improving-outcomes-and-efficiency",
    category: "Enterprise AI",
    image: publicAsset("img8.png"),
    excerpt: "How AI is transforming healthcare delivery, improving patient outcomes, and increasing operational efficiency.",
    readTime: "8 min read",
    date: "Apr 29, 2025",
  },
  {
    id: 9,
    title: "How Retail Businesses Are Using AI to Personalize Customer Experiences",
    slug: "how-retail-businesses-are-using-ai-to-personalize-customer-experiences",
    category: "Enterprise AI",
    image: publicAsset("img9.png"),
    excerpt: "How AI is enabling retail businesses to create personalized customer experiences and drive sales.",
    readTime: "8 min read",
    date: "Apr 29, 2025",
  },
  {
    id: 10,
    title: "How AI Is Driving Digital Transformation Across Industries",
    slug: "how-ai-is-driving-digital-transformation-across-industries",
    category: "Research",
    image: publicAsset("img10.png"),
    excerpt: "Traditional digital transformation focuses on digitizing workflows. AI-driven transformation goes further by introducing intelligence into those workflows.",
    readTime: "8 min read",
    date: "Apr 29, 2025",
  },
  {
    id: 11,
    title: "5 Proven AI Use Cases Delivering ROI for Enterprises",
    slug: "5-proven-ai-use-cases-delivering-roi-for-enterprises",
    category: "Enterprise AI",
    image: publicAsset("img11.png"),
    excerpt: "Where exactly does AI deliver measurable return on investment? We explore five proven AI use cases that are already delivering strong ROI in real-world enterprise environments.",
    readTime: "7 min read",
    date: "Apr 22, 2025",
  },
  {
    id: 12,
    title: "The Enterprise AI Playbook: From Strategy to Business Impact",
    slug: "the-enterprise-ai-playbook-from-strategy-to-business-impact",
    category: "Enterprise AI",
    image: publicAsset("img12.png"),
    excerpt: "A structured approach for enterprises to move from AI strategy to real-world business impact, ensuring that AI initiatives deliver scalable, measurable, and sustainable value.",
    readTime: "9 min read",
    date: "Apr 15, 2025",
  },
  {
    id: 13,
    title: "AI Agents: The Next Evolution of Enterprise Automation",
    slug: "ai-agents-the-next-evolution-of-enterprise-automation",
    category: "Agents",
    image: publicAsset("img13.png"),
    excerpt: "AI Agents represent a shift from automation of tasks to automation of outcomes—introducing reasoning, adaptability, and autonomy into business processes.",
    readTime: "8 min read",
    date: "Apr 8, 2025",
  },
  {
    id: 14,
    title: "Automating Business Processes with AI: A Practical Guide",
    slug: "automating-business-processes-with-ai-a-practical-guide",
    category: "Enterprise AI",
    image: publicAsset("img14.png"),
    excerpt: "A practical approach for enterprises to understand, design, and implement AI-powered business process automation effectively.",
    readTime: "8 min read",
    date: "Apr 1, 2025",
  },
  {
    id: 15,
    title: "Unlocking Productivity with AI-Powered Knowledge Management",
    slug: "unlocking-productivity-with-ai-powered-knowledge-management",
    category: "Enterprise AI",
    image: publicAsset("img15.png"),
    excerpt: "How AI-powered knowledge management is driving measurable productivity impact for modern enterprises by turning static data into intelligent, actionable insights.",
    readTime: "7 min read",
    date: "Mar 25, 2025",
  },
  {
    id: 16,
    title: "Real-World Enterprise AI Success Stories and Lessons Learned",
    slug: "real-world-enterprise-ai-success-stories-and-lessons-learned",
    category: "Research",
    image: publicAsset("img16.png"),
    excerpt: "The difference between successful AI adoption and failed pilots is not just technology—it is execution, data readiness, and alignment with business goals.",
    readTime: "8 min read",
    date: "Mar 18, 2025",
  },
  {
    id: 17,
    title: "Sovereign AI: Why Enterprises and Nations Are Building Independent AI Systems",
    slug: "sovereign-ai-why-enterprises-and-nations-are-building-independent-ai-systems",
    category: "Enterprise AI",
    image: publicAsset("img17.png"),
    excerpt: "Sovereign AI refers to the development and deployment of AI systems that are fully controlled within a specific organization, enterprise, or country—ensuring ownership of data, infrastructure, models, and decision-making processes.",
    readTime: "7 min read",
    date: "Mar 11, 2025",
  },
  {
    id: 18,
    title: "Compute & AI: The Hidden Engine Powering the Next Wave of Enterprise Intelligence",
    slug: "compute-and-ai-the-hidden-engine-powering-enterprise-intelligence",
    category: "Research",
    image: publicAsset("img18.png"),
    excerpt: "As enterprises rapidly adopt AI, understanding the relationship between compute and AI is becoming critical for building sustainable, high-performance AI systems.",
    readTime: "7 min read",
    date: "Mar 4, 2025",
  },
];
const categories = ["All", "Research", "Engineering", "Agents", "RAG",  "Enterprise AI"];

// ─── Neural Canvas ───────────────────────────────────────────────────────────
function NeuralBackground() {
  const canvasRef = useRef(null);
  const animRef = useRef(null);
  const nodesRef = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      canvas.height = canvas.offsetHeight * window.devicePixelRatio;
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
    };
    resize();
    window.addEventListener("resize", resize);

    const W = () => canvas.offsetWidth;
    const H = () => canvas.offsetHeight;

    const NODE_COUNT = 55;
    nodesRef.current = Array.from({ length: NODE_COUNT }, () => ({
      x: Math.random() * W(),
      y: Math.random() * H(),
      vx: (Math.random() - 0.5) * 0.28,
      vy: (Math.random() - 0.5) * 0.28,
      r: Math.random() * 1.8 + 0.5,
      pulse: Math.random() * Math.PI * 2,
    }));

    const draw = () => {
      ctx.clearRect(0, 0, W(), H());
      const nodes = nodesRef.current;

      nodes.forEach((n) => {
        n.x += n.vx;
        n.y += n.vy;
        if (n.x < 0 || n.x > W()) n.vx *= -1;
        if (n.y < 0 || n.y > H()) n.vy *= -1;
        n.pulse += 0.012;
      });

      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          const dx = nodes[i].x - nodes[j].x;
          const dy = nodes[i].y - nodes[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 130) {
            const alpha = (1 - dist / 130) * 0.12;
            ctx.beginPath();
            ctx.moveTo(nodes[i].x, nodes[i].y);
            ctx.lineTo(nodes[j].x, nodes[j].y);
            ctx.strokeStyle = `rgba(30,144,255,${alpha})`;
            ctx.lineWidth = 0.8;
            ctx.stroke();
          }
        }
      }

      nodes.forEach((n) => {
        const glow = Math.sin(n.pulse) * 0.5 + 0.5;
        const grad = ctx.createRadialGradient(n.x, n.y, 0, n.x, n.y, n.r * 4);
        grad.addColorStop(0, `rgba(30,144,255,${0.6 * glow})`);
        grad.addColorStop(1, "transparent");
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.r * 4, 0, Math.PI * 2);
        ctx.fillStyle = grad;
        ctx.fill();

        ctx.beginPath();
        ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(30,144,255,${0.7 + 0.3 * glow})`;
        ctx.fill();
      });

      animRef.current = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(animRef.current);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        opacity: 0.45,
        pointerEvents: "none",
      }}
    />
  );
}

// ─── Floating Particles ───────────────────────────────────────────────────────
function Particles({ count = 18 }) {
  const particles = Array.from({ length: count }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    size: Math.random() * 3 + 1,
    duration: Math.random() * 8 + 6,
    delay: Math.random() * 5,
    drift: (Math.random() - 0.5) * 60,
  }));

  return (
    <div style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}>
      {particles.map((p) => (
        <motion.div
          key={p.id}
          style={{
            position: "absolute",
            left: p.left,
            top: p.top,
            width: p.size,
            height: p.size,
            borderRadius: "50%",
            background: ACCENT,
            opacity: 0,
          }}
          animate={{
            opacity: [0, 0.7, 0],
            y: [-20, -80],
            x: [0, p.drift],
          }}
          transition={{
            duration: p.duration,
            delay: p.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
}

// ─── Stagger wrapper ─────────────────────────────────────────────────────────
function FadeUp({ children, delay = 0, style = {} }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 36 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      style={style}
    >
      {children}
    </motion.div>
  );
}

// ─── Category Chip ────────────────────────────────────────────────────────────
function CategoryChip({ label, active, onClick }) {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.96 }}
      style={{
        position: "relative",
        padding: "8px 20px",
        borderRadius: 100,
        border: active ? "none" : "1px solid rgba(255,255,255,0.1)",
        background: active ? ACCENT : "rgba(255,255,255,0.04)",
        color: "#fff",
        fontSize: "0.82rem",
        fontFamily: "'Inter', sans-serif",
        fontWeight: active ? 600 : 400,
        cursor: "pointer",
        whiteSpace: "nowrap",
        letterSpacing: "0.03em",
        transition: "background 0.25s, border 0.25s",
        outline: "none",
        flexShrink: 0,
      }}
    >
      {active && (
        <motion.div
          layoutId="activeChip"
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: 100,
            background: ACCENT,
            zIndex: -1,
          }}
          transition={{ type: "spring", bounce: 0.25, duration: 0.4 }}
        />
      )}
      {label}
    </motion.button>
  );
}

// ─── Featured Card ────────────────────────────────────────────────────────────
function FeaturedCard({ blog }) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  return (
    <FadeUp delay={0.1}>
      <motion.div
        onHoverStart={() => setHovered(true)}
        onHoverEnd={() => setHovered(false)}
        animate={{ y: hovered ? -6 : 0, boxShadow: hovered ? `0 32px 80px rgba(30,144,255,0.22)` : "0 0 0 rgba(0,0,0,0)" }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          borderRadius: 24,
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.07)",
          background: "rgba(255,255,255,0.025)",
          backdropFilter: "blur(12px)",
          cursor: "pointer",
        }}
      >
        {/* Image */}
        <div style={{ overflow: "hidden", minHeight: 400 }}>
          <motion.img
            src={blog.image}
            alt={blog.title}
            animate={{ scale: hovered ? 1.06 : 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>

        {/* Content */}
        <div style={{ padding: "52px 52px", display: "flex", flexDirection: "column", justifyContent: "center", gap: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span
              style={{
                display: "inline-block",
                padding: "5px 14px",
                borderRadius: 100,
                background: `rgba(30,144,255,0.15)`,
                color: ACCENT,
                fontSize: "0.72rem",
                fontWeight: 700,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              {blog.category}
            </span>
            <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", fontFamily: "'Inter', sans-serif" }}>
              {blog.date}
            </span>
          </div>

          <h2
            style={{
              fontFamily: "'Sora', sans-serif",
              fontWeight: 800,
              fontSize: "clamp(1.6rem, 2.5vw, 2.6rem)",
              lineHeight: 1.12,
              color: "#fff",
              margin: 0,
              letterSpacing: "-0.02em",
            }}
          >
            {blog.title}
          </h2>

          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              color: "rgba(255,255,255,0.6)",
              lineHeight: 1.8,
              fontSize: "0.97rem",
              margin: 0,
            }}
          >
            {blog.excerpt}
          </p>

          <div style={{ display: "flex", alignItems: "center", gap: 20, marginTop: 8 }}>
            <span style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.8rem", fontFamily: "'Inter', sans-serif" }}>
              {blog.readTime}
            </span>
            <motion.button
              whileHover={{ gap: 12 }}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "12px 28px",
                borderRadius: 12,
                background: ACCENT,
                color: "#fff",
                fontFamily: "'Inter', sans-serif",
                fontWeight: 600,
                fontSize: "0.88rem",
                border: "none",
                cursor: "pointer",
                letterSpacing: "0.02em",
              }}
            onClick={() =>
    navigate(`/blogs/${blog.slug}`)
  }
            >
              Read Article
              <motion.span
                animate={{ x: hovered ? 5 : 0 }}
                transition={{ duration: 0.3 }}
                style={{ display: "inline-flex" }}
              >
                →
              </motion.span>
            </motion.button>
          </div>
        </div>
      </motion.div>

      {/* Mobile version */}
      <style>{`
        @media (max-width: 768px) {
          .featured-grid { grid-template-columns: 1fr !important; }
          .featured-content { padding: 28px !important; }
          .featured-img { min-height: 260px !important; }
        }
      `}</style>
    </FadeUp>
  );
}

// ─── Blog Card ────────────────────────────────────────────────────────────────
function BlogCard({ blog, delay = 0 }) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  return (
    <FadeUp delay={delay}>
      <motion.div
        onHoverStart={() => setHovered(true)}
        onHoverEnd={() => setHovered(false)}
        animate={{
          y: hovered ? -10 : 0,
          boxShadow: hovered ? `0 24px 60px rgba(30,144,255,0.18)` : "0 0 0 rgba(0,0,0,0)",
        }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        style={{
          borderRadius: 20,
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.07)",
          background: "rgba(255,255,255,0.025)",
          backdropFilter: "blur(10px)",
          cursor: "pointer",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Image */}
        <div style={{ overflow: "hidden", height: 220, flexShrink: 0 }}>
          <motion.img
            src={blog.image}
            alt={blog.title}
            animate={{ scale: hovered ? 1.08 : 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        </div>

        {/* Body */}
        <div style={{ padding: "28px 28px 32px", display: "flex", flexDirection: "column", flex: 1, gap: 12 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span
              style={{
                padding: "4px 12px",
                borderRadius: 100,
                background: "rgba(30,144,255,0.12)",
                color: ACCENT,
                fontSize: "0.7rem",
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              {blog.category}
            </span>
            <span style={{ color: "rgba(255,255,255,0.3)", fontSize: "0.75rem", fontFamily: "'Inter', sans-serif" }}>
              {blog.readTime}
            </span>
          </div>

          <h3
            style={{
              fontFamily: "'Sora', sans-serif",
              fontWeight: 700,
              fontSize: "1.15rem",
              lineHeight: 1.3,
              color: "#fff",
              margin: 0,
              letterSpacing: "-0.01em",
            }}
          >
            {blog.title}
          </h3>

          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              color: "rgba(255,255,255,0.55)",
              lineHeight: 1.75,
              fontSize: "0.88rem",
              margin: 0,
              flex: 1,
            }}
          >
            {blog.excerpt}
          </p>

          <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
            <span
              style={{
                color: ACCENT,
                fontFamily: "'Inter', sans-serif",
                fontWeight: 600,
                fontSize: "0.85rem",
              }}
               onClick={() =>
    navigate(`/blogs/${blog.slug}`)
  }
            >
              Read more
            </span>
            <motion.span
              animate={{ x: hovered ? 6 : 0 }}
              transition={{ duration: 0.3 }}
              style={{ color: ACCENT, fontSize: "1rem", display: "inline-flex" }}
            >
              →
            </motion.span>
          </div>
        </div>
      </motion.div>
    </FadeUp>
  );
}

// ─── Radial Glow Spot ─────────────────────────────────────────────────────────
function GlowSpot({ top, left, size = 500, opacity = 0.12, color = ACCENT }) {
  return (
    <div
      style={{
        position: "absolute",
        top,
        left,
        width: size,
        height: size,
        borderRadius: "50%",
        background: `radial-gradient(circle, ${color}, transparent 70%)`,
        opacity,
        filter: "blur(80px)",
        pointerEvents: "none",
        transform: "translate(-50%, -50%)",
      }}
    />
  );
}

// ─── Main Page ────────────────────────────────────────────────────────────────
export default function BlogPage() {
  const [selected, setSelected] = useState("All");
   const heroRef = useRef(null);
   const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ["start start", "end start"],
  });
  const heroY = useTransform(scrollYProgress, [0, 1], [0, 80]);
  const heroOpacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  const featured = blogs.find((b) => b.featured);
  const filtered = selected === "All" ? blogs : blogs.filter((b) => b.category === selected);
  
 
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // use "auto" if you don't want animation
    });
  }, []);

  

  return (
    <>
    <Header1/>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=Inter:wght@400;500;600&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        :root {
          --accent: #1E90FF;
          --bg: #000;
          --text: #fff;
        }

        html, body { background: #000; }

        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #000; }
        ::-webkit-scrollbar-thumb { background: rgba(30,144,255,0.35); border-radius: 3px; }

        .blog-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 28px;
        }

        .featured-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
        }

        @media (max-width: 1024px) {
          .blog-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 640px) {
          .blog-grid { grid-template-columns: 1fr; }
          .featured-grid { grid-template-columns: 1fr !important; }
        }

        .noise-overlay {
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: 0;
          opacity: 0.025;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
          background-size: 200px 200px;
        }

        .grid-texture {
          position: absolute;
          inset: 0;
          pointer-events: none;
          opacity: 0.025;
          background-image:
            linear-gradient(rgba(30,144,255,0.8) 1px, transparent 1px),
            linear-gradient(90deg, rgba(30,144,255,0.8) 1px, transparent 1px);
          background-size: 60px 60px;
        }

        .gradient-beam {
          position: absolute;
          pointer-events: none;
        }

        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      {/* Noise overlay */}
      <div className="noise-overlay" />

      <div style={{ background: "#000", color: "#fff", minHeight: "100vh", position: "relative", overflow: "hidden" }}>

        {/* ── HERO ─────────────────────────────────────────────────────────── */}
        <section
          ref={heroRef}
          style={{
            position: "relative",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          {/* Grid texture */}
          <div className="grid-texture" />

          {/* Neural BG */}
          <NeuralBackground />

          {/* Particles */}
          <Particles count={22} />

          {/* Glow orbs */}
          <GlowSpot top="20%" left="30%" size={700} opacity={0.13} />
          <GlowSpot top="70%" left="70%" size={500} opacity={0.1} />
          <GlowSpot top="40%" left="60%" size={400} opacity={0.08} />

          {/* Gradient beams */}
          <div style={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: 2,
            height: "60%",
            background: "linear-gradient(180deg, transparent, rgba(30,144,255,0.25), transparent)",
            filter: "blur(1px)",
            pointerEvents: "none",
          }} />

          {/* Watermark */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2, delay: 0.5 }}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "clamp(5rem, 18vw, 18rem)",
              fontFamily: "'Sora', sans-serif",
              fontWeight: 900,
              letterSpacing: "-0.05em",
              color: "transparent",
              WebkitTextStroke: "1px rgba(30,144,255,0.07)",
              pointerEvents: "none",
              whiteSpace: "nowrap",
              userSelect: "none",
            }}
          >
            BLOG
          </motion.div>

          <motion.div
            style={{ y: heroY, opacity: heroOpacity }}
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="container"
            css={{}}
          >
            <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 5vw, 80px)", position: "relative", zIndex: 1 }}>
              {/* Eyebrow */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.2 }}
                style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 28 }}
              >
                <div style={{ width: 32, height: 1, background: ACCENT }} />
                <span
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: 600,
                    fontSize: "0.78rem",
                    letterSpacing: "0.18em",
                    textTransform: "uppercase",
                    color: ACCENT,
                  }}
                >
                  AnthraSync Newsroom
                </span>
              </motion.div>

              {/* Headline */}
              <div style={{ overflow: "hidden" }}>
                {[
                  { text: "Insights,", delay: 0.3, color: "#fff" },
                  { text: "Research &", delay: 0.45, color: "#fff" },
                  { text: "Engineering", delay: 0.6, color: ACCENT },
                ].map((line, i) => (
                  <div key={i} style={{ overflow: "hidden" }}>
                    <motion.div
                      initial={{ y: "110%", opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ duration: 0.85, delay: line.delay, ease: [0.22, 1, 0.36, 1] }}
                    >
                      <h1
                        style={{
                          fontFamily: "'Sora', sans-serif",
                          fontWeight: 800,
                          fontSize: "clamp(3rem, 7.5vw, 8rem)",
                          lineHeight: 1.0,
                          letterSpacing: "-0.03em",
                          color: line.color,
                          display: "block",
                        }}
                      >
                        {line.text}
                      </h1>
                    </motion.div>
                  </div>
                ))}
              </div>

              {/* Sub */}
              <motion.p
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.9 }}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  color: "rgba(255,255,255,0.55)",
                  maxWidth: 560,
                  lineHeight: 1.85,
                  fontSize: "clamp(0.95rem, 1.2vw, 1.1rem)",
                  marginTop: 28,
                  fontWeight: 400,
                }}
              >
                Technical deep dives, AI research, engineering stories, product updates, and enterprise AI insights from the AnthraSync team.
              </motion.p>

              {/* Meta strip */}
              {/* <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 1.1 }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 32,
                  marginTop: 48,
                  paddingTop: 40,
                  borderTop: "1px solid rgba(255,255,255,0.07)",
                  flexWrap: "wrap",
                }}
              >
                {[["48+", "Articles"], ["12", "Authors"], ["5", "Categories"]].map(([val, label]) => (
                  <div key={label}>
                    <div
                      style={{
                        fontFamily: "'Sora', sans-serif",
                        fontWeight: 800,
                        fontSize: "1.8rem",
                        color: "#fff",
                        letterSpacing: "-0.02em",
                      }}
                    >
                      {val}
                    </div>
                    <div
                      style={{
                        fontFamily: "'Inter', sans-serif",
                        color: "rgba(255,255,255,0.4)",
                        fontSize: "0.78rem",
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        marginTop: 2,
                      }}
                    >
                      {label}
                    </div>
                  </div>
                ))}
              </motion.div> */}
            </div>
          </motion.div> 

          {/* Scroll indicator */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5, duration: 0.8 }}
            style={{
              position: "absolute",
              bottom: 36,
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 8,
              zIndex: 2,
            }}
          >
            <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.7rem", letterSpacing: "0.15em", color: "rgba(255,255,255,0.3)", textTransform: "uppercase" }}>
              Scroll
            </span>
            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
              style={{ width: 1, height: 40, background: "linear-gradient(to bottom, rgba(30,144,255,0.6), transparent)" }}
            />
          </motion.div>
        </section>

        {/* ── FEATURED ─────────────────────────────────────────────────────── */}
        <section style={{ position: "relative", padding: "clamp(60px, 8vw, 120px) 0 0" }}>
          <GlowSpot top="50%" left="80%" size={600} opacity={0.08} />

          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 5vw, 80px)" }}>
            <FadeUp>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 36 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <div style={{ width: 4, height: 28, background: ACCENT, borderRadius: 2 }} />
                  <span
                    style={{
                      fontFamily: "'Sora', sans-serif",
                      fontWeight: 700,
                      fontSize: "1.2rem",
                      color: "#fff",
                    }}
                  >
                    Featured Article
                  </span>
                </div>
              </div>
            </FadeUp>

            {/* Featured card — inline responsive via className */}
            <FadeUp delay={0.1}>
              <FeaturedCardInline blog={featured} />
            </FadeUp>
          </div>
        </section>

        {/* ── CATEGORIES + GRID ─────────────────────────────────────────────── */}
        <section style={{ position: "relative", padding: "clamp(60px, 8vw, 100px) 0 clamp(80px, 10vw, 140px)" }}>
          <GlowSpot top="20%" left="20%" size={600} opacity={0.07} />
          <GlowSpot top="70%" left="80%" size={500} opacity={0.07} />

          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 5vw, 80px)" }}>
            {/* Header */}
            <FadeUp>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 36, flexWrap: "wrap", gap: 16 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <div style={{ width: 4, height: 28, background: ACCENT, borderRadius: 2 }} />
                  <span style={{ fontFamily: "'Sora', sans-serif", fontWeight: 700, fontSize: "1.2rem", color: "#fff" }}>
                    Latest Articles
                  </span>
                </div>
                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.82rem", color: "rgba(255,255,255,0.35)", letterSpacing: "0.05em" }}>
                  {filtered.length} articles
                </span>
              </div>
            </FadeUp>

            {/* Category chips */}
            <FadeUp delay={0.05}>
              <div
                className="scrollbar-hide"
                style={{
                  display: "flex",
                  gap: 10,
                  marginBottom: 48,
                  overflowX: "auto",
                  paddingBottom: 4,
                }}
              >
                {categories.map((cat) => (
                  <CategoryChip
                    key={cat}
                    label={cat}
                    active={selected === cat}
                    onClick={() => setSelected(cat)}
                  />
                ))}
              </div>
            </FadeUp>

            {/* Blog Grid */}
            <AnimatePresence mode="wait">
              <motion.div
                key={selected}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -16 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="blog-grid"
              >
                {filtered.map((blog, i) => (
                  <BlogCard key={blog.id} blog={blog} delay={i * 0.06} />
                ))}
              </motion.div>
            </AnimatePresence>

            {/* Load more */}
            <FadeUp delay={0.2}>
              <div style={{ display: "flex", justifyContent: "center", marginTop: 64 }}>
                <motion.button
                  whileHover={{ scale: 1.03, boxShadow: `0 0 40px rgba(30,144,255,0.25)` }}
                  whileTap={{ scale: 0.97 }}
                  style={{
                    padding: "14px 40px",
                    borderRadius: 12,
                    border: "1px solid rgba(30,144,255,0.35)",
                    background: "rgba(30,144,255,0.06)",
                    color: ACCENT,
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: 600,
                    fontSize: "0.88rem",
                    cursor: "pointer",
                    letterSpacing: "0.04em",
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  Load More Articles
                  <span>↓</span>
                </motion.button>
              </div>
            </FadeUp>
          </div>
        </section>

        {/* ── FOOTER ───────────────────────────────────────────────────────── */}
        {/* <footer
          style={{
            borderTop: "1px solid rgba(255,255,255,0.06)",
            padding: "40px clamp(20px, 5vw, 80px)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 16,
            maxWidth: 1200,
            margin: "0 auto",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: ACCENT }} />
            <span style={{ fontFamily: "'Sora', sans-serif", fontWeight: 700, fontSize: "1rem", color: "#fff" }}>
              AnthraSync
            </span>
          </div>
          <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.78rem", color: "rgba(255,255,255,0.3)" }}>
            © 2025 AnthraSync. All rights reserved.
          </span>
        </footer> */}
      </div>
      <Footer/>
    </>
  );
}

// ─── Featured Card (responsive inline) ───────────────────────────────────────
function FeaturedCardInline({ blog }) {
  const [hovered, setHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <motion.div
      onHoverStart={() => setHovered(true)}
      onHoverEnd={() => setHovered(false)}
      animate={{
        y: hovered ? -6 : 0,
        boxShadow: hovered
          ? `0 32px 80px rgba(30,144,255,0.22)`
          : "0 0 0 rgba(0,0,0,0)",
      }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
        borderRadius: 24,
        overflow: "hidden",
        border: "1px solid rgba(255,255,255,0.07)",
        background: "rgba(255,255,255,0.025)",
        backdropFilter: "blur(12px)",
        cursor: "pointer",
      }}
    >
      <div style={{ overflow: "hidden", minHeight: isMobile ? 260 : 420 }}>
        <motion.img
          src={blog.image}
          alt={blog.title}
          animate={{ scale: hovered ? 1.06 : 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      </div>

      <div
        style={{
          padding: isMobile ? "28px 24px 32px" : "52px 52px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 18,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <span
            style={{
              display: "inline-block",
              padding: "5px 14px",
              borderRadius: 100,
              background: `rgba(30,144,255,0.15)`,
              color: ACCENT,
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            {blog.category}
          </span>
          <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", fontFamily: "'Inter', sans-serif" }}>
            {blog.date}
          </span>
        </div>

        <h2
          style={{
            fontFamily: "'Sora', sans-serif",
            fontWeight: 800,
            fontSize: "clamp(1.5rem, 3vw, 2.6rem)",
            lineHeight: 1.12,
            color: "#fff",
            margin: 0,
            letterSpacing: "-0.02em",
          }}
        >
          {blog.title}
        </h2>

        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            color: "rgba(255,255,255,0.6)",
            lineHeight: 1.8,
            fontSize: "0.97rem",
            margin: 0,
          }}
        >
          {blog.excerpt}
        </p>

        <div style={{ display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap", marginTop: 4 }}>
          <span style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.8rem", fontFamily: "'Inter', sans-serif" }}>
            {blog.readTime}
          </span>
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "12px 28px",
              borderRadius: 12,
              background: ACCENT,
              color: "#fff",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 600,
              fontSize: "0.88rem",
              border: "none",
              cursor: "pointer",
              letterSpacing: "0.02em",
            }}
            onClick={() =>
    navigate(`/blogs/${blog.slug}`)
  }
          >
            Read Article
            <motion.span
              animate={{ x: hovered ? 5 : 0 }}
              transition={{ duration: 0.3 }}
            >
              →
            </motion.span>
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
}